import { loggerConfig } from "@repo/shared/logger";
import pino from "pino";

/** Application logger. Errors are forwarded to Sentry in production. */
export const logger = pino({
  ...loggerConfig,
  name: "web",
  browser: {
    serialize: true,
  },
});
